import { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { obtenerPerfilPersonal, guardarPerfilPersonal } from '../../../actions/configuracion';
import { setAlert } from '../../../actions/alert';

const Perfil = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Perfil personal',
            path: '/perfil_personal'
        }
    ];

    const dispatch = useDispatch();

    const { usuario } = useSelector(state => state.auth);
    
    const [perfilData, setPerfilData] = useState({
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        celular: '',
        email: '',
        password: ''
    });

    const [celularDialCode, setCelularDialCode] = useState('52');

    /* Guardar perfil */
    const onChange = (e) => {
        setPerfilData({
            ...perfilData, [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(!perfilData.celular){
            dispatch(setAlert('El número de celular es obligatorio', 'danger'));
            return;
        }

        if (perfilData.celular && (perfilData.celular.length - celularDialCode.length) !== 10) {
            dispatch(setAlert('El teléfono debe tener 10 dígitos sin contar la lada.', 'danger'));
            return;
        }

        if(!perfilData.email){
            dispatch(setAlert('El correo electrónico es obligatorio', 'danger'));
            return;
        }

        try {
            dispatch(guardarPerfilPersonal(perfilData));
        } catch (error) {
            return false;
        }
    }

    /* Funciones generales */
    const onViewPassword = () => {
        let perfilInputType = document.getElementById('password').type;
        if(perfilInputType === 'password')document.getElementById('password').type = 'text';
        else document.getElementById('password').type = 'password';
    }

    useEffect(() => {
        dispatch(obtenerPerfilPersonal());
    }, []);

    useEffect(() => {
        setPerfilData({
            ...perfilData,
            id: usuario?._id,
            nombre: usuario?.nombre,
            apellido_paterno: usuario?.apellido_paterno,
            apellido_materno: usuario?.apellido_materno,
            celular: usuario?.celular || '',
            email: usuario?.email
        });
    }, [usuario]);    

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return(
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        input[type="file"] {
                            display: none;
                        }
                        
                        .custom-file-upload {
                            border-radius: 50%;
                            display: inline-block;
                            position: relative;
                            padding: 0px;
                            cursor: pointer;
                            background: #fff;
                            margin-bottom: 25px;
                            border: 5px solid #111F62;
                        }
                        
                        .img-wrap{
                            position: relative;
                            width: 200px;
                            height: 200px;
                            overflow: hidden;
                            border-radius: 50%;
                        }

                        .img-upload:before{
                            content: "";
                            font-family: "Font Awesome 6 Free" !important;
                            font-weight: 900;
                            font-size: 90px;
                            position: absolute;
                            padding-top: 50px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;
                            color: #21B4E9;
                            width: 200px;
                            height: 200px;
                            border-radius: 50%;
                            opacity: 0;
                            transition: .5s ease;
                            background-color: #fff;
                        }

                        .img-upload:hover:before{
                            opacity: 1;
                        }

                        #img-photo {
                            width: auto;
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="title-section my-5">Información personal</h3>

                    <div className="row">
                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={perfilData.nombre} onChange={e => onChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={perfilData.apellido_paterno} onChange={e => onChange(e)}/>
                                    <label htmlFor="apellido_paterno">Apellido paterno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={perfilData.apellido_materno} onChange={e => onChange(e)}/>
                                    <label htmlFor="apellido_materno">Apellido materno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <PhoneInput
                                country="mx"
                                preferredCountries={['mx', 'us']}
                                enableSearch={true}
                                placeholder="Celular *"
                                value={perfilData.celular || ''}
                                onChange={(value, countryData) => {
                                    setPerfilData({ ...perfilData, celular: value });
                                    setCelularDialCode(countryData.dialCode);
                                }}
                                inputClass="form-control"
                                containerClass="w-100"
                                inputStyle={{ width: '100%', height: 'calc(3.5rem + 2px)' }}
                                buttonStyle={{ height: 'calc(3.5rem + 2px)' }}
                            />
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Email de acceso" id="email" name="email" value={perfilData.email} onChange={e => onChange(e)}/>
                                    <label htmlFor="email">Correo</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="password" className="form-control" placeholder="Contraseña de acceso" id="password" name="password" autoComplete="off" value={perfilData.password} onChange={e => onChange(e)}/>
                                    <label htmlFor="password">Contraseña</label>
                                </div>
                                <div className="input-group-append">
                                    <button className="btn btn-primary viewPassword" onClick={onViewPassword}><i className="fa-solid fa-eye"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button type="button" className="btn btn-success float-end" onClick={handleSubmit}>Guardar perfil</button>   
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Perfil;